import {
  IToggleSavingAction,
  IState,
} from '../../types/state';

export const toggleSaving = (state: IState, _action: IToggleSavingAction): IState => ({
  ...state,
  saving: !state.saving,
});
